import { css } from "@emotion/react";

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 18px;
  border: 1px solid #eef0f5;
  border-radius: 18px;
  padding: 20px;
  margin-top: 12px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
`;

export const message = css`
  color: #64748b;
  line-height: 1.5;
`;

export const button = css`
  width: 100%;
  border: 0;
  border-radius: 14px;
  background: #34189a;
  color: #ffffff;
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    background: #25106f;
    transform: translateY(-1px);
  }
`;